/**
 *
 * SponsorsSidebar
 *
 */

import React, { memo, FunctionComponent } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../app/store';
import { StyledCard } from '../../global-styles';
import { StyledSponsorsSidebar } from './styledComponents';
import { useEventAds } from '../../api/useEventAds';
import { AppQueryParamsConfigMap } from '../../app/constants';
import { useQueryParams } from 'use-query-params';

interface IProps {
  expanded: boolean;
}

const connector = connect((state: RootState) => ({}), {});

type PropsFromRedux = ConnectedProps<typeof connector>;

const SponsorsSidebar: FunctionComponent<IProps & PropsFromRedux> = ({
  expanded,
}) => {
  const [query] = useQueryParams(AppQueryParamsConfigMap);
  const { data: sponsors } = useEventAds(query.e);

  if (!sponsors?.length) {
    return null;
  }

  if (expanded) {
    return (
      <StyledSponsorsSidebar>
        <div className="sponsors-title">Sponsors</div>
        <div className="sponsors-content">
          {sponsors?.map((item, index) => (
            <div className="sponsors-item" key={index}>
              <a href={item.url} target="_blank" rel="noreferrer">
                <div className="sponsors-item-pic">
                  <img src={item.imageUrl} alt={item.name} />
                </div>
                <div className="sponsors-item-title">{item.name}</div>
              </a>
            </div>
          ))}
        </div>
      </StyledSponsorsSidebar>
    );
  } else {
    return (
      <StyledCard className="card-vertical">
        <div className="card-body">
          <div className="txt fw-7 fs-16">Sponsors</div>
        </div>
      </StyledCard>
    );
  }
};

export default connector(memo(SponsorsSidebar));
